/**
 * This file is being used to load the images dynamically.
 * In the future, I think all of the images for footbowl should be in one
 * or more spritesheets to reduce the number of requests for assets.
 */

export const getScoreDigit = (score: number, team: 'Home' | 'Visitor', digit: 0 | 1): string => {
  if (score < 10 && digit === 0) {
    return '';
  }

  return require(
    `@/assets/footbowl/scores/${
      team.toLowerCase()[0] + (digit === 0 ? 'l' : 'r')
    }/${score.toString().charAt(score < 10 && digit === 1 ? 0 : digit)}.png`,
  );
};

export const getDigit = (num: number | null, digit: number, numDigits = 2) => {
  if (num === null) {
    return '';
  }

  const numStr = (new Array(numDigits - 1).fill('0').join('') + num).slice(-numDigits);
  return require(`@/assets/footbowl/numbers/${numStr[digit]}.png`);
};

export const getDigits = (num: number | null, numDigits = 2): string[] => {
  if (num === null) {
    return [];
  }

  const digits = num.toString().length;
  return new Array(digits).fill(0).map((_, i) => getDigit(num, i, digits));
};
